import { MascotBubble } from '@tankef/ui';

import type { StepType } from '@reactour/tour';

export const DASHBOARD_TOUR_ID = 'dashboard';

export const dashboardSteps: StepType[] = [
  // ── Saldo ─────────────────────────────────────────────────────────────────
  {
    selector: '[data-tour="balance"]',
    position: 'bottom',
    content: (
      <MascotBubble emotion="happy" size="sm" direction="right" showPointer={false}>
        Aquí ves tu saldo disponible y cuánto tienes retenido por operaciones en proceso.
      </MascotBubble>
    ),
  },

  // ── Módulos del sidebar ───────────────────────────────────────────────────
  {
    selector: '[data-tour="nav-wallet"]',
    position: 'right',
    content: (
      <MascotBubble emotion="neutral" size="sm" direction="right" showPointer={false}>
        Desde <strong>Wallet</strong> depositas, retiras y revisas todos tus movimientos.
      </MascotBubble>
    ),
  },
  {
    selector: '[data-tour="nav-investments"]',
    position: 'right',
    content: (
      <MascotBubble emotion="thinking" size="sm" direction="right" showPointer={false}>
        En <strong>Inversiones</strong> pones tu dinero a trabajar. Cada proyecto muestra tasa,
        plazo y nivel de riesgo.
      </MascotBubble>
    ),
  },
  {
    selector: '[data-tour="nav-savings"]',
    position: 'right',
    content: (
      <MascotBubble emotion="celebrating" size="sm" direction="right" showPointer={false}>
        <strong>Cajas de ahorro y tandas</strong> — ahorra en grupo o de forma individual. ¡Tu turno
        de cobrar llega más rápido de lo que crees!
      </MascotBubble>
    ),
  },

  // ── Notificaciones ────────────────────────────────────────────────────────
  {
    selector: '[data-tour="header-notifications"]',
    position: 'bottom',
    content: (
      <MascotBubble emotion="hint" size="sm" direction="left" showPointer={false}>
        Aquí aparecen tus <strong>notificaciones en tiempo real</strong>: pagos recibidos,
        movimientos y alertas de seguridad.
      </MascotBubble>
    ),
  },

  // ── Idioma ────────────────────────────────────────────────────────────────
  {
    selector: '[data-tour="header-language"]',
    position: 'bottom',
    content: (
      <MascotBubble emotion="neutral" size="sm" direction="left" showPointer={false}>
        Cambia el <strong>idioma</strong> de la app en cualquier momento — Español o English.
      </MascotBubble>
    ),
  },

  // ── Cuenta / perfil ───────────────────────────────────────────────────────
  {
    selector: '[data-tour="header-account"]',
    position: 'bottom',
    content: (
      <MascotBubble emotion="neutral" size="sm" direction="left" showPointer={false}>
        Tu <strong>menú de cuenta</strong>: perfil, preferencias, seguridad y cierre de sesión. Todo
        en un solo lugar.
      </MascotBubble>
    ),
  },

  // ── Ayuda ─────────────────────────────────────────────────────────────────
  {
    selector: '[data-tour="help-btn"]',
    position: 'top',
    content: (
      <MascotBubble emotion="callcenter" size="sm" direction="right" showPointer={false}>
        ¡Soy Cash! Estoy aquí siempre que me necesites. Ábrela para ver guías, FAQs y tutoriales
        paso a paso de cada módulo.
      </MascotBubble>
    ),
  },
];
